<template>
  <div>
    <a-row type="flex" class="about">
      <a-col :xs="24">
        <h1>US County Level</h1>
        <p>
          The following API endpoints are pulling data from the New York Times US County Level dataset. You can find and download the original data from <a rel="noreferrer" target="_blank" href="https://github.com/nytimes/covid-19-data/blob/master/us-counties.csv">github.com/nytimes/covid-19-data/blob/master/us-counties.csv</a>
        </p>
        <p>

        </p>
      </a-col>
    </a-row>

  <a-row type="flex" justify="space-around" class=" text-left">
    <a-col :xs="22">
      <p class='request'>
        <a-tag color="blue"><strong>GET</strong></a-tag>
        <span class='request-endpoint'>api/covid19/nytimes/county</span>
      </p>
      <p>
        Full URL: <a target="_blank" href='https://api.joeczubiak.com/api/covid19/nytimes/county'>https://api.joeczubiak.com/api/covid19/nytimes/county</a>
      </p>

    </a-col>
  </a-row>
  <a-row type="flex" justify="space-around" class="text-left">
    <a-col :xs="22">

      <a-divider orientation='left'><h3>Parameters</h3></a-divider>

      <j-param
        name='date'
        type='string'
        :required='false'
        description='Filters the results to a specific date.
        Format yyyy-mm-dd. Example "2020-04-09"'
      >
      </j-param>

      <j-param
        name='county'
        type='string'
        :required='false'
        description='Filters the results to the county provided.'
      >
      </j-param>

      <j-param
        name='state'
        type='string'
        :required='false'
        description='Filters the data to state provided. Full state name required. Eg California'
      >
      </j-param>

      <j-param
        name='fips'
        type='string'
        :required='false'
        description='Filters the results to the fips provided. (The FIPS code is a code given to the county by the federal government.)'
      >
      </j-param>

      <j-param
        name='cases'
        type='integer'
        :required='false'
        description='Filters the data to only those with cases equaling the number provided.'
      >
      </j-param>

      <j-param
        name='deaths'
        type='integer'
        :required='false'
        description='Filters the data to only those with deaths equaling the number provided.'
      >
      </j-param>


      <j-param
        name='page'
        type='integer'
        :required='false'
        defaultvalue='1'
        description='Set to the pagination page number you wish to receive.'
      >
      </j-param>

      <j-param
        name='per_page'
        type='integer'
        :required='false'
        defaultvalue="100"
        description='The number of results to be returned from the request.'
      >
      </j-param>

      <j-param
        name='order'
        type='string'
        :required='false'
        defaultvalue="asc"
        description='Specifies the order to sort the results. Accepts "asc" or "desc."'
      >
      </j-param>

      <j-param
        name='order_by'
        type='string'
        :required='false'
        defaultvalue="date"
        description='Orders the content by a particular field. Specify the field.'
      >
      </j-param>
    </a-col>
  </a-row>

  <a-row type="flex" justify="space-around" class="text-left">
    <a-col :xs="22">
      <a-divider orientation='left'><h3>Results</h3></a-divider>
      <p>
        The following is a sample response in the format you will receive from making a request.
      </p>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="200" key="1">
          <j-code language="js" :inline="false">
            <pre class="language-js">
              <code class="language-js">
{
  "data": [
    {
      "date": "2020-04-14",
      "county": "Halifax",
      "state": "Virginia",
      "fips": "51083",
      "cases": 7,
      "deaths": 0
    },
    ...
  ],
  "status": "200",
  "links": {
    "first": "https://api.joeczubiak.com/api/covid19/nytimes/county?page=1",
    "last": "https://api.joeczubiak.com/api/covid19/nytimes/county?page=586",
    "prev": null,
    "next": "https://api.joeczubiak.com/api/covid19/nytimes/county?page=2"
  },
  "attribution": {
    "required": true,
    "message": "You must provide attribution when using this data.",
    "sample_attribution_text": "This data is being provided free from the NY Times.",
    "commercial_uses_allowed": false
  },
  "meta": {
    "current_page": 1,
    "from": 1,
    "last_page": 586,
    "path": "https://api.joeczubiak.com/api/covid19/nytimes/county",
    "per_page": 100,
    "to": 100,
    "total": 58588
  }
}
              </code>
            </pre>
          </j-code>
        </a-tab-pane>
        <a-tab-pane tab="422" key="2">
          <p>
            A sample request producing validation errors.
          </p>
          <j-code language="js" :inline="false">
            <pre class="language-js">
              <code class="language-js">
"errors": [
    {
        "title": "422_bad_request",
        "detail": "The given data was invalid.",
        "source": {
            "county": {
                "place": [
                    "County not found in dataset"
                ]
            },
        },
        "status": 422
    }
]
              </code>
            </pre>
          </j-code>
        </a-tab-pane>
      </a-tabs>

    </a-col>
  </a-row>

  <a-row type="flex" justify="space-around" class="text-left">
    <a-col :xs="22">
      <a-divider orientation='left'><h3>Examples</h3></a-divider>
      <j-code language="js" :inline="false">
        <pre class="language-js">
          <code class="language-js">
const fetch = require('node-fetch');

fetch('https://api.joeczubiak.com/api/covid19/nytimes/county', {
  method: 'GET',
  headers: {
    'Accept': 'application/json'
  }
})
.then(response => {
  console.log(
    `Response: ${response.status}`
  );
  return response.json();
})
.then(json => console.log(json))
.catch(err => console.error(err));
        </code>
      </pre>
      </j-code>
    </a-col>
  </a-row>
</div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Free Coronavirus API - New York Times COVID-19 County Level Data API',
    meta: [
      { name: 'description', content: 'This free coronavirus API lets you access JSON formatted NY Times County Level COVID-19 data. This data was compiled by the New York Times and is being made available free from Joe\'s API service. APIs for developers to use.' },
    ],
  },
};
</script>

<style lang="less" scoped>
.ant-descriptions-title {
  text-align: left;
}
.request-type {
}
.request-endpoint {
  font-size: 1.3em;
  background: #e6f7ff;
  border-radius: 5px;
  padding: .2em 0.5em;
  color: var(--color-primary);
  border-color: var(--color-primary);
  border: solid 1px;
}
</style>
